export const ACTION_EVENT_LEADS_LOADED = 'EVENT_LEADS_LOADED',
    ACTION_EVENT_SINGLE_LEAD_UPDATED = 'EVENT_SINGLE_LEAD_UPDATED';

export default {
    load: (eventId, leads) => {
        return {
            type: ACTION_EVENT_LEADS_LOADED,
            eventId,
            leads,
        };
    },
    update: (eventId, lead) => {
        return {
            type: ACTION_EVENT_SINGLE_LEAD_UPDATED,
            eventId,
            lead,
        };
    },
};
